export default (element) => {
  const clickHandle = (e) => {
    e.preventDefault();
    document.dispatchEvent(
      new CustomEvent(
        e.currentTarget.dataset.type.toLowerCase() === 'outfit'
          ? 'look-overlay:open'
          : 'quick-view:open',
        {
          detail:
            e.currentTarget.dataset.type.toLowerCase() === 'outfit'
              ? {
                  id: e.currentTarget.dataset.id,
                }
              : {
                  handle: e.currentTarget.dataset.handle,
                },
        },
      ),
    );
  };

  const init = () => {
    element
      .querySelectorAll('[data-type]')
      .forEach((el) => el.addEventListener('click', clickHandle));
  };

  init();
};
